export default __webpack_public_path__ + "static/media/online-learning.ecec572e.svg";